<template>
	<div class="content-class">
		<v-tabs v-model="active" color="black" dark slider-color="primary">
			<v-tab :key="'botGroup'" ripple>Groupe de bots</v-tab>
			<v-tab :key="'Logs'" ripple>Logs</v-tab>

			<v-tab-item :key="'botGroup'">
				<bot-groups-form v-model="document" />

				<v-btn :disabled="loading" color="error" @click="deleteUser()">
					<v-progress-circular v-if="loading" indeterminate color="primary"></v-progress-circular>
					Supprimer
				</v-btn>
			</v-tab-item>

			<v-tab-item :key="'Logs'">
				<log-list
					:url="'logs?filter=references.reference:$eq:botgroups;references.referenceId:$eq:' + $route.params.id"
				>
				</log-list>
			</v-tab-item>
		</v-tabs>
	</div>
</template>
<script>
import BotGroupsForm from '../../components/botGroups/botGroups.form'
import LogList from '../../components/logs/log.list.vue'

import { ERROR, SUCCESS } from '../../variables'

export default {
	components: { BotGroupsForm, LogList },
	data() {
		return {
			loading: false,
			active: null,
			document: null,
		}
	},
	methods: {
		deleteUser() {
			this.axios
				.delete('bot-groups/' + this.$route.params.id)
				.then((response) => {
					this.$router.push({ name: 'BotGroupsList' })
					this.$store.dispatch(SUCCESS, 'Groupe de bot supprimé')
				})
				.catch((err) => {
					this.$store.dispatch(ERROR, err)
				})
		},
	},
	mounted() {
		this.axios
			.get('bot-groups/' + this.$route.params.id)
			.then((response) => {
				this.document = response.data
			})
			.catch((err) => {
				this.$store.dispatch(ERROR, err)
			})
	},
}
</script>
<style lang="scss">
.content-class {
	width: 100%;
	height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/pages/botGroups/botGroups.detail.vue